import {
  TextField,
  Paper,
  Typography,
  Box,
  Grid,
  Link,
  } from "@mui/material";

import React, { useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton";
import { useTheme } from "@emotion/react";
import { tokens } from "../../theme";

import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { ApiType } from "../../services/ApiTags";
import {
  getFromLocalStorage,
  saveToLocalStorage,
} from "../../utils/localStorageUtils";
import {
  BASIC_AUTH_TOKKEN,
  MESSAGE_KEY,
  SESSION_ID,
} from "../../constants/LocalStorageKeyValuePairString";
import useAxiosHook from "../../hooks/UseAxios";
import {
  ALERT,
  ERROR,
  ERROR_WHILE_FETCHING_DATA,
  NO_INTERNET_CONNECTION_FOUND,
  PROCESSING_PLEASE_WAIT,
  SUCCESS,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
} from "../../constants/Strings";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import DebugLog from "../../utils/DebugLog";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import { SnackbarProvider, useSnackbar } from "notistack";
import {
  collapseMenu,
  isAuthPageAtom,
  selectedSidebarTab,
  sessionIdStatus,
  showErrorAlertDialog,
  showSuccessAlertDialog,
} from "../../config/AppConfig";
import { useAtom } from "jotai";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import ConnectionStatus from "../../utils/ConnectionStatus";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import * as CONSTANT from "../../constants/Constant";
import { generateBasicAuthHeader } from "../../services/BasicAuthHashing";
import ShowSuccessDialog from "../../components/ShowSuccessDialog";

const ResetPasswordOnUrlLinkClick = () => {
  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [success, setSuccess] = useState("");

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [, setSessionIdState] = useAtom(sessionIdStatus);
  const [, setIsCollapsed] = useAtom(collapseMenu);
  const [, setAuthStatus] = useAtom(isAuthPageAtom);


  const [, setSelected] = useAtom(selectedSidebarTab);

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const [getSuccessDialogStatus, setSuccessDialog] = useAtom(showSuccessAlertDialog);

  const [loading, setLoading] = useState(false);
  const isNetworkConnectionAvailable = UseOnlineStatus();
  const [getProgressbarText, setProgressbarText] = useState("");

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [authParamValue, setAuthParam] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  
  //const authParam =btoa(unescape(encodeURIComponent(queryParams.get("authParam"))))
  const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@&])[A-Za-z\d@&]{8,20}$/;

  const { data, error, showProgressBar, fetchData } = useAxiosHook();


  useEffect(() => {
    setSelected(CONSTANT.RESET_PASSWORD_ON_URL_LINK_CLICK);
    setIsCollapsed(false);
    saveToLocalStorage(SESSION_ID, "");
    setAuthStatus(true);
    getNewConfigration();
  }, [isNetworkConnectionAvailable, enqueueSnackbar, Navigate]);




  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  useEffect(() => {
    if (showProgressBar) {
      setProgressbarText(PROCESSING_PLEASE_WAIT);
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBar]);


  useEffect(() => {
    if (error) {
      if (
        error.data != null &&
        error.data.responseCode != null &&
        error.data.responseCode != -1
      ) {
        const message = error.response != null ? error.response : error.message;
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
       

        
      } else {
        const message =
          error.data != null ? error.data.displayErrorMessage : error.message;

          
        showErrorAlert(
          ERROR,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
        
      }
    }
  }, [error]);

  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  function showSuccessAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setSuccessDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const getNewConfigration = () => {
    requestBasicAuth();
  };

  // Generate Basic Auth hHeader()
  const requestBasicAuth = () => {
    if (isNetworkConnectionAvailable) {
      const headerTokken = generateBasicAuthHeader();
      const authToken = "BASIC " + headerTokken;

      fetchData(
        process.env.REACT_APP_BASIC_AUTH_API_URL,
        ApiType.BASIC_AUTH,
        ApiType.GET_METHOD,
        null,
        {
          headers: {
            Authorization: authToken,
          },
        },
        (data) => {
          saveToLocalStorage(MESSAGE_KEY, data.messageKey);
          saveToLocalStorage(BASIC_AUTH_TOKKEN, data.basicAuthToken);
        }
      );
    }
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };


  // const classes = useStyles();
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
  
    if (formData.newPassword === "") {
      newErrors.newPassword = "Please enter your new password!";
    } else if (formData.newPassword.length < 8) {
      newErrors.newPassword = "New Password minimum length should not be less than 8 character!";
    }else if (!passwordRegex.test(formData.newPassword)) {
      newErrors.newPassword =
        "Password must be between 8 to 16 character, including at least 1 upper case, 1 lower case, 1 numeric & 1 sepecial charcter (e.g. @,!,&,#)";
    }  else if (formData.confirmPassword === "") {
      newErrors.confirmPassword = "Please enter your confirmation password!";
    } else if (formData.confirmPassword.length < 8) {
      newErrors.confirmPassword = "Confirm Password Minimum length should not be less than 8 character!";
    } else if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword =
        "New password and confirmation password do not match!";
    }

    if (Object.keys(newErrors).length === 0) {
      
      callChangePasswordApi();
    } else {
      setErrors(newErrors);
    }
  };

  function callChangePasswordApi() {
    try {
      if (isNetworkConnectionAvailable) {
        const authParam = queryParams.get("authParam")
        const correctedValue = authParam ? authParam.replace(/ /g, '+') : null;
        const requestObject = {
          confirmedNewPassword: formData.confirmPassword,
          newPassword: formData.newPassword,
          encryptedValue: correctedValue,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.RESET_PASSWORD
        ).then((encryptedContentData) => {
          fetchData(
            process.env.REACT_APP_RESET_PASSWORD_API_URL,
            ApiType.RESET_PASSWORD,
            ApiType.POST_METHOD,
            encryptedContentData,
            {},
            (data) => {
              if (data !== null) {
                // showSuccessAlert(
                //  SUCCESS,
                //   "Password changed successfully"
                // );
                showSuccessAlert(
                  SUCCESS,
                  "Password changed successfully"
                 );
                //alert("Password changed successfully")
               // navigate(CONSTANT.LOGIN);
              }
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  function onConfirmButtonResponseReceived(){
    navigate(CONSTANT.LOGIN);
  }

  return (
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />

     <ShowSuccessDialog
          status={getSuccessDialogStatus}
          title={title}
          content={content}
          onConfirmButtonClick={onConfirmButtonResponseReceived}
        />

        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}

        <Grid
          container
          component="main"
          sx={{
            height: "100vh",
            width: "125% !important",
            position: "absolute",
            left: "-25%",
          }}
        >
          {/* BG */}

          <Grid
            container
            display="flex"
            justifyContent="center"
            alignItems="center"
            xs={12}
            sx={{
              backgroundImage: "url(/assets/login/Login-BG-2.jpg)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center center",
            }}
          >
            <Grid
              container
              direction={"row"}
              p={3}
              justifyContent="space-around"
              alignItems={"center"}
              xs={8.8}
            >
              <Grid item xs={12} sm={5} md={4} lg={5} xl={6} pb={5}>
                <Box display="flex" alignItems="center">
                  <img src="assets/common/Logo-White.svg" width={320} />
                </Box>
              </Grid>

              {/* Login Container */}
              <Grid
                item
                xs={12}
                sm={8}
                md={5}
                lg={5}
                xl={6}
                component={Paper}
                elevation={12}
                sx={{
                  borderRadius: 3,
                  border: "1px solid #E4EBF7",
                  padding: "0",
                }}
              >
                {/* Header */}
                <Box
                  sx={{
                    width: "100%",
                    py: 6,
                    px: 3,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h5"
                    color={colors.grey[100]}
                    fontWeight="bold"
                    sx={{ m: "0 0 15px 0px", fontSize: 24 }}
                  >
                    Reset Password
                  </Typography>

                  {/* Form Elements */}
                  <Box sx={{ width: "100%", padding: "0 5%" }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        pb={2}
                        sx={{ fontSize: "14px", color: "#888" }}
                      >
                        Please change your password
                      </Typography>
                      <Box>
                        <form>
                          <Box>
                            {/* <TextField
                              variant="outlined"
                              margin="normal"
                              fullWidth
                              name="currentPassword"
                              label="Login Id"
                              //type={showCurrentPassword ? 'text' : 'password'}
                              type="text"
                              value={formData.currentPassword}
                              onChange={handleInputChange}
                              error={Boolean(errors.currentPassword)}
                              helperText={errors.currentPassword}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={toggleCurrentPasswordVisibility}
                                      edge="end"
                                    >
                                      {showCurrentPassword ? (
                                        <FaEyeSlash />
                                      ) : (
                                        <FaEye />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            /> */}
                            <TextField
                              variant="outlined"
                              margin="normal"
                              fullWidth
                              name="newPassword"
                              label="New Password"
                              type={showNewPassword ? "text" : "password"}
                              //value={newPassword}
                              //onChange={(e) => setNewPassword(e.target.value)}

                              value={formData.newPassword}
                              onChange={handleInputChange}
                              error={Boolean(errors.newPassword)}
                              helperText={errors.newPassword}
                              inputProps={{ maxLength: 16 }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={toggleNewPasswordVisibility}
                                      edge="end"
                                    >
                                      {showNewPassword ? (
                                        <FaEyeSlash />
                                      ) : (
                                        <FaEye />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                            <TextField
                              variant="outlined"
                              margin="normal"
                              fullWidth
                              name="confirmPassword"
                              label="Confirm New Password"
                              type={showConfirmPassword ? "text" : "password"}
                              //value={confirmPassword}
                              //onChange={(e) => setConfirmPassword(e.target.value)}

                              value={formData.confirmPassword}
                              onChange={handleInputChange}
                              error={Boolean(errors.confirmPassword)}
                              helperText={errors.confirmPassword}
                              inputProps={{ maxLength: 16 }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={toggleConfirmPasswordVisibility}
                                      edge="end"
                                    >
                                      {showConfirmPassword ? (
                                        <FaEyeSlash />
                                      ) : (
                                        <FaEye />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                            <Box mt={3} pb={3}>
                              <CustomButton
                                btnBG={colors.primary[100]}
                                btnColor={colors.grey[900]}
                                btnTxt={"CHANGE PASSWORD"}
                                btnBorder={"1px solid" + colors.primary[100]}
                                onClick={handleSubmit}
                              ></CustomButton>
                            </Box>
                          </Box>
                        </form>
                      </Box>

                      <Box sx={{ mt: 1 }}>
                        {/* <CustomButton
                            // btnBG = "#FFF"
                            // btnColor="#000"
                            btnTxt="Reset Password"
                            // onClick = {navigate(CONSTANT.LOGIN)}
                           onClick={handleSubmit}
                          ></CustomButton> */}
                        <Grid container justifyContent={"center"}>
                          <Grid item mt={1}>
                            <Link
                              href="/"
                              variant="body2"
                              sx={{
                                textDecoration: "none",
                                fontWeight: "500",
                                fontSize: "0.75rem",
                              }}
                            >
                              Go Back
                            </Link>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                {/* Header */}

                <Box sx={{ position: "absolute", bottom: "0", right: "2%" }}>
                  <Typography
                    variant="h5"
                    color={colors.grey[900]}
                    fontWeight="400"
                    sx={{ m: "0 0 15px 0px", fontSize: 16 }}
                  >
                    2024 © YTLC. All Rights Reserved.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          {/* BG */}
        </Grid>
      </SnackbarProvider>
    </Box>
  );
};

export default ResetPasswordOnUrlLinkClick;
